import { CLASS_NAMES } from '../../utils/constants'
import Explosion from './Explosion'
import Fallable from './Fallable'

export default class Pillar extends Fallable {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: true,
      isFlat: true,
      isPickable: false,
      isCrushable: false,
      level
    })
    this.strength = 5
  }

  runningOver(el) {
    if(el.classes.includes("Barrel")) {
      this.inactive = true
    }
  }

  overrunBy(el) {
    if(el.constructor.className === Explosion.className) {
      this.alien.visible = false
      this.alien.destroy()
      // this.alien = null
      // this.level.onDestroyElement(this)
    }
  }
}
Pillar.className = CLASS_NAMES.PILLAR
